import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface RankingListProps {
  items: Movie[];
}

export default function RankingList({ items }: RankingListProps) {
  return (
    <aside className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5 h-full">
      <div className="flex items-center gap-2.5 mb-4">
        <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
          <i className="ri-trophy-line text-lg"></i>
        </span>
        <div>
          <h2 className="font-heading font-bold text-lg text-foreground-950">口碑排行榜</h2>
          <p className="text-xs text-foreground-500">按站内评分排序</p>
        </div>
      </div>
      <ol className="divide-y divide-background-200">
        {items.map((movie, i) => (
          <li key={movie.id}>
            <Link
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-3 py-3 cursor-pointer"
            >
              <span
                className={`w-6 text-center font-heading font-black text-base shrink-0 ${
                  i < 3 ? "text-accent-500" : "text-background-400"
                }`}
              >
                {i + 1}
              </span>
              <div className="w-10 h-14 rounded-md overflow-hidden bg-background-100 shrink-0">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 榜单封面`}
                  title={`${movie.title} - 影视详情`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {movie.title}
                </p>
                <p className="text-xs text-foreground-500 truncate mt-0.5">
                  {movie.year} · {movie.genres[0]}
                </p>
              </div>
              <span className="text-sm font-semibold text-accent-600 shrink-0">
                {movie.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}